import React from "react";

interface FilterPanelProps {
  selectedTypes: string[];
  handleCheckboxChange: (type: string) => void;
  filterSearch: string;
  setFilterSearch: (val: string) => void;
  noAddressFound: boolean;
  t: (key: string) => string;
  resetFilter: () => void;
  handleApply: () => void;
  setShowFilterPanel: (val: boolean) => void;

  sortOrder: string;
  setSortOrder: (val: string) => void;
}

const FilterPanel: React.FC<FilterPanelProps> = ({
  selectedTypes,
  handleCheckboxChange,
  filterSearch,
  setFilterSearch,
  noAddressFound,
  t,
  resetFilter,
  handleApply,
  setShowFilterPanel,
  sortOrder,
  setSortOrder,
}) => (
  <>
    <div
      className="fixed z-[1000] inset-0 bg-gray-500 bg-opacity-50"
      onClick={() => setShowFilterPanel(false)}
    ></div>

    <div className="absolute lg:w-2/5 z-[2000] right-0 p-4 border mt-2 rounded-md mr-8 bg-white shadow-md">
      <div className="mb-4">
        <label className="block mb-4 font-semibold">
          {t("filteraddress")}
        </label>

        <div className="flex space-x-4">
          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={selectedTypes.includes("home")}
              onChange={() => handleCheckboxChange("home")}
            />
            <span>{t("home")}</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={selectedTypes.includes("office")}
              onChange={() => handleCheckboxChange("office")}
            />
            <span>{t("office")}</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={selectedTypes.includes("other")}
              onChange={() => handleCheckboxChange("other")}
            />
            <span>{t("other")}</span>
          </label>
        </div>
      </div>

      {/* Sort */}
      <div className="mb-4 flex items-center justify-between">
        <span className="font-semibold">Sort By</span>

        <div className="flex rounded-lg border border-blue-600 overflow-hidden">
          <button
            type="button"
            onClick={() => setSortOrder("az")}
            className={`px-6 py-2 text-sm font-medium transition-all ${sortOrder === "az"
                ? "bg-blue-600 text-white"
                : "bg-white text-blue-600 hover:bg-blue-50"
              }`}
          >
            A-Z
          </button>

          <button
            type="button"
            onClick={() => setSortOrder("za")}
            className={`px-6 py-2 text-sm font-medium border-l border-blue-600 transition-all ${sortOrder === "za"
                ? "bg-blue-600 text-white"
                : "bg-white text-blue-600 hover:bg-blue-50"
              }`}
          >
            Z-A
          </button>
        </div>
      </div>

      <div className="mb-4">
        <label htmlFor="filterSearch" className="block mb-1 font-semibold">
          {t("SearchHere")}
        </label>

        <input
          type="text"
          id="filterSearch"
          value={filterSearch}
          onChange={(e) => setFilterSearch(e.target.value)}
          className="w-full p-2 border rounded-md"
          placeholder={t("SearchKeyword")}
        />
      </div>

      {noAddressFound && (
        <p className="text-red-500 mb-4">
          {t("noAddresses")}
        </p>
      )}

      <div className="flex gap-2 justify-between">
        <button
          onClick={resetFilter}
          className="px-4 py-2 bg-gray-400 text-white rounded-md hover:bg-gray-500"
        >
          {t("reset")}
        </button>

        <button
          onClick={handleApply}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          {t("apply")}
        </button>
      </div>
    </div>
  </>
);

export default FilterPanel;